/**
 * A signed stat: "+1.2" / "-0.4", and unsigned "0.0" when it rounds to zero, so a sign only shows when it says
 * something (Trevor, 2026-10-16: every +/-, impact, expectation and value column, the ownership strips, the hover
 * breakdowns and the Player Stats signed formats). ASCII hyphen-minus, so a copied value still parses as a number.
 * A non-finite value renders blank, never "NaN".
 */
export function formatSigned(value: number, decimals = 1): string {
  if (!Number.isFinite(value)) return "";
  const magnitude = Math.abs(value).toFixed(decimals);
  if (Number(magnitude) === 0) return magnitude;
  return `${value > 0 ? "+" : "-"}${magnitude}`;
}
